/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { MyHistoryTypes, MyHistoryState } from './types';

const INITIAL_STATE: MyHistoryState = {
  my_history: {
    total_itens_vencidos: 0,
    itens_vencidos: [],
    licitacoes_por_modalidade: [],
    licitacoes_por_regiao: [],
    licitacoes_por_orgao: [],
    licitacoes_por_portal: [],
    followups: [],
    count_bidding_monitored: 0,
    total_investimento: 0,
    itens: [],
    total_itens: 0,
  },
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
  request_followups: {
    loading: false,
    loaded: false,
    error: false,
  },
  request_list_itens: {
    loading: false,
    loaded: false,
    error: false,
  },
};

const reducer: Reducer<MyHistoryState> = (state = INITIAL_STATE, { type, result }) => {
  return produce(state, (draft) => {
    switch (type) {
      case MyHistoryTypes.GET_MY_HISTORY_REQUEST:
        draft.request = { loading: true, loaded: false, error: false };
        break;

      case MyHistoryTypes.GET_MY_HISTORY_SUCCESS:
        draft.my_history.total_itens_vencidos = result?.data?.total_itens_vencidos;

        draft.my_history.itens_vencidos = result?.data?.itens_vencidos;

        draft.my_history.total_investimento = result?.data?.total_investimento;

        draft.my_history.licitacoes_por_modalidade = result?.data?.licitacoes_por_modalidade;

        draft.my_history.licitacoes_por_regiao = result?.data?.licitacoes_por_regiao;

        draft.my_history.licitacoes_por_orgao = result?.data?.licitacoes_por_orgao;

        draft.my_history.licitacoes_por_portal = result?.data?.licitacoes_por_portal;

        draft.my_history.count_bidding_monitored = result?.data?.count_bidding_monitored ?? 0;

        draft.request = { loading: false, loaded: true, error: false };
        break;

      case MyHistoryTypes.GET_MY_HISTORY_FAILURE:
        draft.request = { loading: false, loaded: false, error: true };
        break;

      case MyHistoryTypes.GET_FOLLOWUPS_REQUEST:
        draft.request_followups = { loading: true, loaded: false, error: false };
        break;

      case MyHistoryTypes.GET_FOLLOWUPS_SUCCESS:
        draft.my_history.followups = result?.data?.followups_history;
        draft.request_followups = { loading: false, loaded: true, error: false };
        break;

      case MyHistoryTypes.GET_FOLLOWUPS_FAILURE:
        draft.request_followups = { loading: false, loaded: false, error: true };
        break;

      case MyHistoryTypes.GET_LIST_ITENS_REQUEST:
        draft.request_list_itens = { loading: true, loaded: false, error: false };
        break;

      case MyHistoryTypes.GET_LIST_ITENS_SUCCESS:
        draft.my_history.itens = result?.data?.itens;
        draft.my_history.total_itens = result?.data?.total_itens;
        draft.request_list_itens = { loading: false, loaded: true, error: false };
        break;
      case MyHistoryTypes.GET_LIST_ITENS_FAILURE:
        draft.request_list_itens = { loading: false, loaded: false, error: true };
        break;

      default:
    }
  });
};

export default reducer;
